module.exports = __webpack_public_path__ + "static/media/service_business.27800932.png";